
export enum RatingStatusCd {
	FAILED = 'Failed',
	SUCCESSFUL = 'Successful'}
